import React from 'react';
import { AiFillLinkedin, AiFillGithub } from 'react-icons/ai';
import { IoMdMail } from "react-icons/io";
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* padding: 1rem 0 0 0; */
  opacity: 81%;
  width: 41%;
  @media (max-width: 576px) {
    width: 87%;
  }
`;

const IconLink = styled.a`
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: whitesmoke;
  background-color: ${(props) => props.bgColor};
  /* opacity: 90%; */
  padding: 0rem 0.4rem;
  margin-right: 1rem;
  border-radius: 3px;
  text-decoration: none;
  transition: color 0.3s ease;
  span{
    font-size: 1.8rem;
    font-weight: bold;
    padding: 0 3px;
  }
  &:hover {
    /* color: whitesmoke;
    background-color: transparent; */
    /* color: ${props=> props.bgColor}; */
    transform: scale(1.1);
    transition: transform 0.1s ease-in;
    font-weight: normal;
  }
`;

const SocialIcons = () => {
    const handleMailClick = () => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Container>
            <IconLink href='mailto: isachin.imp@gmail.com' bgColor="orangered">
                <IoMdMail size={22} color='whitesmoke' /><span>Email</span>
            </IconLink>
            <IconLink href="https://github.com/ksachin7" target='_blank' bgColor="whitesmoke" style={{color: "black"}}>
                <AiFillGithub size={21} color='black' /><span>GitHub</span>
            </IconLink>
            <IconLink href="https://www.linkedin.com/in/sachin-k-187419184" target='_blank' bgColor="#06a">
                <AiFillLinkedin size={20} color="whitesmoke" /><span>LinkedIn</span>
            </IconLink>
        </Container>
    );
};

export default SocialIcons;
